import DataTableV2ItemView from '@/agilis/components/DataTableV2/DataTableV2ItemView/DataTableV2ItemView'
import EntityDetailsMobile from '@/agilis/mobile/EntityDetailsMobile/EntityDetailsMobile.vue'
import renderMixinMobile from '../ListCardMobileMixins/renderMixinMobile'

export default {
  name: 'DataTableV2ItemViewMobile',
  mixins: [DataTableV2ItemView, renderMixinMobile],
  components: {
    EntityDetailsMobile
  }
}
